import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

import { SystemActionTypes } from '@tamalelibs/redux/actions/system.actions';
import { ContactService } from '@tamalelibs/services/contact.service';
import { ScreenService } from '@tamalelibs/services/screen.service';
import { EntityBrief } from '@tamalelibs/models/entity-brief.model';
import { Store } from '@ngrx/store';
import { AppState } from '..';

@Injectable()
export class SystemEffects {
    constructor(
        private _actions$: Actions,
        private _contactService: ContactService,
        private _screenService: ScreenService,
        private _store: Store<AppState>,
    ) { }

    initCurrentContactEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SystemActionTypes.INIT_CURRENT_CONTACT),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._contactService.getContactDetail(payload).pipe(
                map(response => {
                    return ({
                        type: SystemActionTypes.INIT_CURRENT_CONTACT_SUCCESS,
                        payload: EntityBrief.parse(response)
                    });
                })
            );
        })
    ));

    getVisibleScreensEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SystemActionTypes.GET_VISIBLE_SCREENS),
        switchMap(() => {
            return this._screenService.getVisibleScreens().pipe(
                map(response => response['screen-list']),
                map(response => {
                    return {
                        type: SystemActionTypes.GET_VISIBLE_SCREENS_SUCCESS,
                        payload: response
                    };
                }),
                catchError(err => {
                    return of({
                        type: SystemActionTypes.GET_VISIBLE_SCREENS_FAILED,
                        payload: err.message
                    });
                })
            );
        })
    ));

    loadManageScreensEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SystemActionTypes.GET_SCREENS),
        map((action: any) => action.payload),
        switchMap(payload => {
            return this._screenService.getAllScreens().pipe(
                map(response => response['screen-list']),
                map(response => {
                    const visibleScreens = [];
                    response.forEach(item => {
                        if (item.visible) {
                            visibleScreens.push(item);
                        }
                    });
                    this._store.dispatch({
                        type: SystemActionTypes.GET_VISIBLE_SCREENS_SUCCESS,
                        payload: visibleScreens
                    });
                    return ({
                        type: SystemActionTypes.GET_SCREENS_SUCCESS,
                        payload: response
                    });
                })
            );
        }),
        catchError(err => {
            this._store.dispatch({
                type: SystemActionTypes.GET_VISIBLE_SCREENS_FAILED,
                payload: err.message
            });
            return of({
                type: SystemActionTypes.GET_SCREENS_FAILED,
                payload: err.message
            });
        })
    ));

    getUnCategorizedIdEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SystemActionTypes.GET_UNCATEGORUZEEID),
        switchMap(() => {
            return this._screenService.getUnCategorizedId().pipe(
                map(response => {
                    return {
                        type: SystemActionTypes.GET_UNCATEGORUZEEID_SUCCESS,
                        payload: response
                    };
                }),
                catchError(err => {
                    return of({
                        type: SystemActionTypes.GET_UNCATEGORUZEEID_FAILED,
                        payload: err.message
                    });
                })
            );
        })
    ));

    loadContactsEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SystemActionTypes.GET_CONTACTS),
        map((action: any) => action.payload),
        switchMap(payload => {
            return this._contactService.getAllContactList().pipe(
                map(response => {
                    const contactList = this._contactService.mapContactList(response);
                    return ({
                        type: SystemActionTypes.GET_CONTACTS_SUCCESS,
                        payload: contactList
                    });
                })
            );
        }),
        catchError(err => {
            return of({
                type: SystemActionTypes.GET_CONTACTS_FAILED,
                payload: err.message
            });
        })
    ));
}
